
import React, { useMemo } from 'react';
import { MetricCard, SpinnerDotted } from '../../atoms';
import { UserAlert } from '../../atoms/alerts';
import { Bargraph } from '../../organisms';
import { healthCheckMale, male_circle } from '../../../../assets/images';
import { commaingNumber } from '../../../../utils';
import { UtilizationSankyChart } from '../../../tailwind/organisms';

const WalletUtilizationCommon = ({ metricObj,  loading, benefitName, walletUtilizationObj, uniqueUsers, activeCustomerCount }) => {
    const { repeat_users, bardataWallet, barLabelsWallet, barBgColorsWallet, activeEmployeeUtilizationPercentage, repeatSponsoredUserCount, unique_users,
            repeatSponsoredUserCountPercentage, monthOnMonthMaxValue, totalAmountSpent } = metricObj;

    const getStepSize = (maxValue) => {
        if (maxValue <= 0) return 10;
        else if (maxValue <= 10) return 1;
        else if (maxValue <= 100) return 10;
        else if (maxValue <= 1000) return 100;
        else if (maxValue <= 10000) return 1000;
        else if (maxValue <= 100000) return 10000;
        else if (maxValue <= 1000000) return 100000;
        else if (maxValue <= 10000000) return 1000000;
         return 10000000;
      };

    const roundUpToNearest = (num, roundTo) => {
        var res = Math.ceil(num / roundTo) * roundTo

        return res<= 0 ? 100 : res;
    };

    const step = getStepSize(monthOnMonthMaxValue);
    const roundedMax = roundUpToNearest(monthOnMonthMaxValue, step);
    const maxWithHeadroom = roundedMax + step;
    const pharmacy = benefitName?.toLowerCase()?.includes('pharmacy');

    return (
        <div>
            {/* { !loading ? (
                totalAmountSpent > 0 ? (
                    <div>
                        <p className='text-gray-600 text-base font-semibold mt-8 mb-3 leading-none'>
                            User and Amount Distribution
                        </p>
                        <UtilizationSankyChart
                            sankeyData={ChartWalletUtilizationData}
                            classes='px-8 py-20 border bg-white border-gray-200'
                            height={450}
                        />
                    </div>
                ) : null
            ) : (
                <div className='h-40 flex items-center justify-center'>
                    <SpinnerDotted />
                </div>
            )} */}
            <div>
                <div className='text-gray-600 text-base font-semibold mt-6 mb-3 leading-none'>
                    Unique & Repeat Users
                </div>
                <div className='flex flex-row space-between'>
                        <MetricCard
                            loading={loading}
                            loaderHeight={120}
                            svgsrc={healthCheckMale}
                            titleClasses='font-semibold text-gray-800'
                            title='Employees Who Utilized'
                            subTitle={`Employees who took at least one ${benefitName?.toLowerCase()}`}
                            metricClasses='flex mt-0 text-gray-500'
                            metricValue={<span className='ml-10 font-semibold text-3xl text-gray-700'>{commaingNumber(unique_users)}</span>}
                            metricValueSuffix={`${activeEmployeeUtilizationPercentage > 0 ? `${Math.round(activeEmployeeUtilizationPercentage)}%` : 'less than 1%'} of active employees`}
                            classes='w-1/2 inline-block mr-5'
                        />
                        <MetricCard
                            loading={loading}
                            loaderHeight={120}
                            svgsrc={male_circle}
                            titleClasses='font-semibold text-gray-800'
                            title='Repeat users'
                            subTitle={`Employees who took more than one ${benefitName?.toLowerCase()}`}
                            metricClasses='flex mt-0 text-gray-500'
                            metricValue={<span className='ml-10 font-semibold text-3xl text-gray-700'>{commaingNumber(repeatSponsoredUserCount)}</span>}
                            metricValueSuffix={`${repeatSponsoredUserCountPercentage > 0 ?  `${Math.round(repeatSponsoredUserCountPercentage)}%` : 'less than 1%'} of active employees`}
                            classes='w-1/2 inline-block'
                        />
                </div>
            </div>

            <p className='text-sm text-gray-600 mt-2 mb-0 italic leading-none'>
                *Dependents are excluded
            </p>

            {(totalAmountSpent > 0) && (<div>
                {/* <div>
                    <div className='text-base font-semibold text-gray-500 mt-6 mb-3 leading-none'>
                        WALLET UTILIZATION
                    </div>
                    <div className='flex flex-row space-between'>
                        <MetricCard
                            loading={loading}
                            loaderHeight={120}
                            svgsrc={healthCheckMale}
                            titleClasses='font-semibold text-gray-800'
                            title='Amount Utilized'
                            subTitle={`Total utilized amount for ${benefitName?.toLowerCase()}`}
                            metricClasses='flex mt-0 text-gray-500'
                            metricValue={<span className='ml-10 font-semibold text-3xl text-gray-700'>{commaingNumber(amountUtilizedPercentageAmount)}</span>}
                            metricValueSuffix={`${amountUtilizedPercentage}% of ₹${totalWalletAmount}`}
                            classes='w-1/2 inline-block mr-5'
                        />
                        <MetricCard
                            loading={loading}
                            loaderHeight={120}
                            svgsrc={male_circle}
                            titleClasses='font-semibold text-gray-800'
                            title='Avg. utilized per employee'
                            subTitle={`Total utilized sponsored wallet amount for the ${benefitName?.toLowerCase()}`}
                            metricClasses='flex mt-0 text-gray-500'
                            metricValue={<span className='ml-10 font-semibold text-3xl text-gray-700'>{commaingNumber(averageUtilizePerEmployeegeAmount)}</span>}
                            metricValueSuffix={`${averageUtilizePerEmployeegeAmountPercentage}% of ₹${averageAmountAddedPerEmployees}`}
                            classes='w-1/2 inline-block'
                        />
                    </div>
                </div>

                <p className='text-sm text-gray-600 mt-2 mb-0 italic leading-none'>
                    *dependents are not counted
                </p> */}

                <div className='text-gray-600 text-base font-semibold mt-12 mb-3 leading-none'>Monthly {pharmacy ? 'Order' : 'Appointment'} Trend</div>
                <div className={'mt-3 rounded-md ' + (loading ? '' : 'bg-white ') + (bardataWallet && bardataWallet?.length === 0 ? 'pt-6 ' : '')} >
                    {bardataWallet && bardataWallet?.length === 0 && (
                        <UserAlert
                            para={`Months data is not available`}
                            paraClasses=' font-semibold text-gray-600'
                            imgClasses=' h-5 w-5'
                            classes=' p-4 ml-6 mr-4'
                        />
                    )}
                    <Bargraph
                        id='walletutilizationbargraph'
                        loading={loading}
                        loaderHeight={300}
                        data={bardataWallet}
                        labels={barLabelsWallet}
                        backgroundColor={barBgColorsWallet}
                        height='300px'
                        type='bar'
                        ticks={{
                            min: 0,
                            max: maxWithHeadroom,
                            stepSize: step,
                        }}
                        dataPoints='amount'
                        barTag='amount'
                        xAxesLabel={'Months of the year'}
                        yAxesLabel={pharmacy ? 'Number of orders delivered' : 'Number of completed appointments'}
                    />
                </div>
            </div>
            )}
        </div>
    )
};

export default WalletUtilizationCommon;
